var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapCustomMarker',{staticClass:"marker",class:_vm.sizeClass,attrs:{"alignment":"center","marker":_vm.marker.position}},[_c('img',{attrs:{"src":_vm.markerImage,"alt":_vm.marker.location.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }